<template>
  <section class="exhibitor-inner-two" id="app">
    <div class="container-row">
      <div class="heading-row heading-row-v4">
      </div>
      <ExhibitorList />
    </div>
  </section>
</template>

<script>
import ExhibitorList from "./ExhibitorList/ExhibitorListing";
export default {
  name: "exhibitorlist",
  components: {
    ExhibitorList
  },
  computed: {
  },
  mounted() {
     /*new*//*
    const style2 = document.createElement("link");
    style2.setAttribute(
      "href",
      "https://www.hydrogenexpo.com/css/style.css"
    );
    style2.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style2);

    const style3 = document.createElement("link");
    style3.setAttribute(
      "href",
      "https://www.hydrogenexpo.com/css/CustomStyles.css"
    );
    style3.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style3);

    const style5 = document.createElement("link");
    style5.setAttribute(
      "href",
      "https://www.hydrogenexpo.com/css/GPSisotop.css?v=1.031"
    );
    style5.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style5);

    const style4 = document.createElement("link");
    style4.setAttribute(
      "href",
      "https://www.hydrogenexpo.com/css/GPSnewEditionStyles.css?v=3.02193"
    );
    style4.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style4);


    const style6 = document.createElement("link");
    style6.setAttribute(
      "href",
      "http://hydrogenexpo.s.cmshelp.dk/css/devStyle.css"
    );
    style6.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style6);

    const style7= document.createElement("link");
    style7.setAttribute(
      "href",
      "http://hydrogenexpo.s.cmshelp.dk/css/style.css"
    );
    style7.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style7);


    const style8= document.createElement("link");
    style8.setAttribute(
      "href",
      "https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.css"
    );
    style8.setAttribute(
      "rel",
      "stylesheet");
    document.head.appendChild(style8);




    const recaptchaScript1 = document.createElement("script");
    recaptchaScript1.setAttribute(
      "src",
      "https://www.hydrogenexpo.com//scripts/tcagenda.js?v=1.41"
    );
    document.head.appendChild(recaptchaScript1);

   */ 

  },
  methods: {
  }
};
</script>





